import { string } from 'prop-types';
import { Button } from '@fff-web/fff-ui-shared';
import { trackUpgradeStarted } from '../../../utils/analytics';
import { UPGRADE_PAGE_URL } from '../../../utils/constants';
import Detail from '../Detail/Detail';

const UpgradeMembership = ({ cta, desc, title }) => {
  const handleClickUpgrade = () => {
    trackUpgradeStarted(cta).finally(() => {
      window.location = UPGRADE_PAGE_URL;
    });
  };
  return (
    <Detail icon="fa-star" title={title} description={desc}>
      <>
        <br />
        <Button data-testid="upgrade-cta" width="100%" onClick={handleClickUpgrade}>
          {cta}
        </Button>
      </>
    </Detail>
  );
};

UpgradeMembership.propTypes = {
  cta: string.isRequired,
  desc: string.isRequired,
  title: string.isRequired,
};

export default UpgradeMembership;
